// extracted by css-extract-rspack-plugin
export default {"QuestionListItemRoot":"IfUBi","CheckboxContainer":"RMgSM"};